<template>
  <transition-group name="sort-list" tag="ol">
    <li
      class="sort-list-item"
      :class="{ 'is-active': active(index) }"
      v-for="(item, index) in items"
      :key="item.id || item.meta.id || index"
    >
      <slot v-bind="{ ...item, active: active(index) }" />
    </li>
  </transition-group>
</template>

<script>
export default {
  props: {
    items: {
      type: [Object, Array],
      default: () => {},
    },
    activeIndex: {
      type: [Number, null],
      default: null,
    },
  },

  computed: {
    active() {
      return index => this.activeIndex !== null && this.activeIndex === index
    },
  },
}
</script>

<style lang="postcss">
:root {
  --rightdistance: 50px;
}

.sort-list {
  &-move {
    transition: all 1s;
  }

  &-enter-active,
  &-leave-active {
    transition: all var(--animation-speed, 1s);
    max-height: 20rem;
  }

  &-enter,
  &-leave-to {
    opacity: 0;
    max-height: 0;
    transform: translateX(var(--rightdistance));
  }

  &-enter {
    --rightdistance: 0;
  }
}
</style>
